<div class="example">
    <!-- <form (ngSubmit)="onSubmit()" [formGroup]="form"> -->
    <form class="k-form row g-3 align-items-center" [formGroup]="form">
        <div class="col-12">
            <h5>Equipos</h5>

        </div>
        <ng-container *ngFor="let question of questions">

            <div [ngClass]="question.ngClass">
                <ng-container [ngSwitch]="question.controlType">

                    <textbox-question *ngSwitchCase="'textbox'" [question]="question" [form]="form"></textbox-question>
                    <dropdown-question *ngSwitchCase="'dropdown'" [question]="question" [form]="form"></dropdown-question>
                    <numerictextbox-question *ngSwitchCase="'numerictextbox'" [question]="question" [form]="form"></numerictextbox-question>
                    <checkbox-question *ngSwitchCase="'checkbox'" [question]="question" [form]="form"></checkbox-question>
                    <textarea-question *ngSwitchCase="'textarea'" [question]="question" [form]="form"></textarea-question>
                    <datepicker-question *ngSwitchCase="'datepicker'" [question]="question" [form]="form"></datepicker-question>
                    <multiselect-question *ngSwitchCase="'multiselect'" [question]="question" [form]="form"></multiselect-question>

                </ng-container>
            </div>
        </ng-container>


        <div class="k-form-buttons col-12">
            <button class="k-button k-primary" (click)="submitForm()">
              Guardar
            </button>
            <button class="k-button" (click)="clearForm()">Cancelar</button>
        </div>
    </form>


</div>